import React from 'react';

import { locale, getTailwindColor } from '@trqk/utils';

import { IconInfoCircle, Tooltip } from '../../../..';

const tertiary400 = getTailwindColor('tertiary-400');

/**
 * Explains that the square bullet at the end of each line in the QuarterlyRunRate chart corresponds
 * to the most recent quarterly royalties for a given entity.
 */
export const BulletKey = (): JSX.Element => (
    <div className="text-tertiary-400 text-sm font-semibold flex justify-end items-center mr-10 pt-4">
        <svg viewBox="0 0 8 8" height={8} xmlns="http://www.w3.org/2000/svg">
            <rect width={8} height={8} fill={tertiary400} />
        </svg>
        <div className="ml-2">
            {
                locale.enUS.MANAGE_STATEMENTS.TOTAL_ROYALTIES
                    .MOST_RECENT_QUARTERLY_ROYALTIES
            }
            <Tooltip
                background="light"
                message={
                    <div
                        className="grid mt-3"
                        style={{ gridTemplateColumns: '32px auto' }}
                    >
                        <IconInfoCircle
                            addClasses="ml-1"
                            fillColor="primary-500"
                            width={20}
                        />
                        <div className="text-left text-tertiary-400 mr-3 mb-3 font-normal">
                            <p className="font-medium">
                                {
                                    locale.enUS.MANAGE_STATEMENTS
                                        .TOTAL_ROYALTIES.MOST_RECENT_MARKER
                                }
                            </p>
                        </div>
                    </div>
                }
                minWidth={300}
                maxWidth={300}
                position="top"
            >
                <div className="text-left">
                    <IconInfoCircle
                        addClasses="ml-1"
                        fillColor="primary-500"
                        width={20}
                    />
                </div>
            </Tooltip>
        </div>
    </div>
);
